import { mergePageThemes } from "@ncino/pax-ui";
import { allPageThemes } from "../generated/page-aggregations";

export { gaxGradients as gradients, gaxMaterialColors as materialColors } from "@ncino/pax-ui";

// Shared with App.tsx's PaxProvider so off-screen renders (e.g.
// exportComponentToPdf's wrapWithProviders) can reuse the exact same theme
// the on-screen app renders with, without importing App.tsx itself (which
// would create a circular import through the generated route tree).
export const paxCombinedTheme = mergePageThemes(allPageThemes);
